module.exports = __webpack_public_path__ + "static/organic-6fa66b8d685819a232250809ddb862b9.jpg";